import { render, staticRenderFns } from "./TableHeadWithSort.vue?vue&type=template&id=db429b0a&"
import script from "./TableHeadWithSort.vue?vue&type=script&lang=js&"
export * from "./TableHeadWithSort.vue?vue&type=script&lang=js&"
import style0 from "./TableHeadWithSort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports